<template>
  <div>
    <div v-if="saved_reSendCurrentTime" class="pt-4 text-center">
      <span class="text-message">Resend OTP in </span>
      <span class="back-button">{{ saved_reSendCurrentTime }}s</span>
    </div>
    <div v-else class="text-center forgot-password pt-4" v-on:click="reSendOtp">
      Resend OTP
    </div>
    <vue-recaptcha
      :sitekey="recaptchaSiteKey"
      ref="recaptcha"
      @verify="verifyMethod"
      @expired="onCaptchaExpired"
      @error="recaptchaError"
      @render="renderMethod"
      size="invisible"
    ></vue-recaptcha>
  </div>
</template>

<script>
import Services from "../services";
import CommonCode from "./mixins/CommonCode";
import UserUtils from "./mixins/UserUtils";
import { EventBus } from "../events";
import { VueRecaptcha } from "vue-recaptcha";
import { mapState } from "vuex";
import * as Sentry from "@sentry/vue";

export default {
  mixins: [CommonCode, UserUtils],

  props: {
    typedata: {
      type: String,
    },
    tokendata: {
      type: String,
    },
  },

  data() {
    return {
      interval: 1,
      timerValue: 60,
      recaptchaSiteKey: window.env.RECAPTCHA_SITE_KEY,
      reCaptchaToken: null,
    };
  },
  components: { VueRecaptcha },
  computed: {
    ...mapState("projects", {
      unleashValue: "unleashEnalbed",
    }),
  },
  methods: {
    onInterval() {
      if (this.saved_reSendCurrentTime <= 0) {
        clearInterval(this.saved_timerInterval);
      } else {
        this.timerCounter(
          parseInt(this.saved_reSendCurrentTime) - parseInt(this.interval)
        );
      }
    },
    // Sending DetectSMS event to ShellApp to initiate SMS reading
    sendPostMsgToAPP() {
      if (this.isShellApp && this.fetch_data.type == 'phone') {
        this.sendPostMessageToShellApp('INITIATE_AUTO_DETECT_SMS')
      }
    },
    
    async generateOtp() {
      this.sendPostMsgToAPP();
      //TODO: Will remove the logs once generate OTP issue is fixed
      if (this.tokendata) {
        /**Call Generate OTP api with access token */
        Services.generateOtp(this.fetch_data, this.typedata, this.tokendata)
          .then((response) => {
            this.startInterval(response);
          })
          .catch((err) => {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: "Something went wrong while generating OTP, Please try again after sometime.",
              errorCode: 0,
            });
            Sentry.withScope((scope) => {
              scope.setTag("pageUrl", window.location.href);
              scope.setTag("Application", "ACCOUNTS");
              Sentry.captureMessage(`GENERATE OTP ${err}`, {
                level: "error",
              });
            });
          });
      } else {
        /*** CALL Generate OTP API with username
         * At Error:
         * At success:
         *  **/
        let payload = {
          isdCode: this.fetch_data.isdcode,
        };
        if (this.fetch_data.type == "phone") {
          payload["username"] =
            this.fetch_data.isdcode + this.fetch_data.username;
        } else {
          payload["username"] = this.fetch_data.username;
        }
        payload["recaptcha-token"] = this.reCaptchaToken;
        Services.generateOTP_v2(payload)
          .then((response) => {
            this.startInterval(response);
          })
          .catch((err) => {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: "Something went wrong while generating OTP, Please try again after sometime.",
              errorCode: 0,
            });
            console.log(err);
            Sentry.withScope((scope) => {
              scope.setTag("pageUrl", window.location.href);
              scope.setTag("Application", "ACCOUNTS");
              Sentry.captureMessage(`GENERATE OTP ${err}`, {
                level: "error",
              });
            });
          });
      }
    },

    startInterval(response) {
      this.timerInterval = setInterval(this.onInterval, this.interval * 1000);
      this.setTimerInterval(this.timerInterval);
      this.requestId = response.data.requestId;
      this.$emit("getRequest", this.requestId);
    },

    reSendOtp() {
      this.$root.$emit("hideMessage", true);
      let properties = {
        requestData: this.fetch_data,
      };
      EventBus.$emit(
        "captureEvents",
        "accounts_resend-otp:customer_click",
        properties
      );
      this.timerCounter(this.timerValue);
      // Execute Recaptcha to get token
      this.$refs.recaptcha.execute();
    },

    timerCounter(value) {
      this.$store.dispatch("users/updateTime", value).then(() => {});
    },

    setTimerInterval(value) {
      this.$store.dispatch("users/updateTimeInterval", value).then(() => {});
    },
    //Emit on recaptcha verified response is the successful recaptcha response
    verifyMethod(e) {
      this.$refs.recaptcha.reset();
      this.reCaptchaToken = e;
      this.generateOtp();
    },
    //Emit on recaptcha expired
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    //Emit on recaptcha mounted on DOM id is the widget id of the component
    recaptchaError(e) {
      console.log("recaptchaError", e);
    },
    //Emit when recaptcha encounters an error
    renderMethod(e) {
      console.log("renderMethod called", e);
    },
  },

  async mounted() {
    this.timerCounter(this.timerValue);
    await this.$refs.recaptcha.execute("login");
  },
  destroyed() {
    this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
      msg: null,
      errorCode: 0,
    });
  },
};
</script>

<style >
.grecaptcha-badge {
  visibility: hidden !important;
}
</style>